import React from 'react';
import { ExternalLink, FileText } from 'lucide-react';

const Blog = () => {
  return (
    <section id="blog" className="relative py-24 bg-gradient-to-b from-transparent to-black/30">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Blog & Insights</h2>
          <div className="w-20 h-1 bg-cyan-500 mx-auto"></div>
        </div>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-8 hover:bg-white/10 hover:border-cyan-500/50 transition-all duration-300">
          <div className="flex items-start gap-6">
            <div className="p-4 rounded-lg bg-cyan-500/20 border border-cyan-500/30">
              <FileText size={32} className="text-cyan-400" />
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-semibold text-white mb-3">Read My Articles</h3>
              <p className="text-white/70 leading-relaxed mb-6">
                I share insights about AI/ML, software engineering, and the latest developments 
                in agentic AI frameworks on LinkedIn. Check out my posts to learn more about 
                my thoughts on technology and innovation.
              </p>
              <a
                href="https://www.linkedin.com/in/prathamesh-bheemanathi/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-cyan-500 hover:bg-cyan-600 text-black font-medium rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
              >
                View Posts on LinkedIn
                <ExternalLink size={18} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;